export default [
  {
    path: "/chat-partner",
    name: "chat-partner",
    component: () => import("@/views/chatPartner/Chat.vue"),
    meta: {
      resource: "chatPartner",
      action: "read",
      title: "breadcrumb.chatPartner",
      contentRenderer: "sidebar-left",
      contentClass: "chat-application",
    },
  },
];
